import React from "react";
import { motion } from "framer-motion";

export default function PageHero({ overline, title, accent, subtitle, bg, testid }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden px-6 pb-16 pt-40 sm:pt-48">
      {bg && (
        <motion.img
          src={bg} alt="" aria-hidden
          initial={{ scale: 1.2, opacity: 0 }}
          animate={{ scale: 1.1, opacity: 0.28 }}
          transition={{ duration: 1.6, ease: "easeOut" }}
          className="pointer-events-none absolute inset-0 h-full w-full object-cover"
        />
      )}
      <div className="pointer-events-none absolute inset-0" style={{ background: "linear-gradient(to bottom, rgba(5,5,5,0.5), var(--bg))" }} />
      <div className="relative mx-auto max-w-7xl">
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
          className="mb-6 text-xs uppercase tracking-[0.3em] text-gold">{overline}</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.1 }}
          className="max-w-4xl font-head text-5xl font-light leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
          {title} {accent && <span className="text-gold italic">{accent}</span>}
        </motion.h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.25 }}
            className="mt-8 max-w-2xl text-base leading-relaxed text-[var(--text-2)] sm:text-lg">{subtitle}</motion.p>
        )}
        <div className="tartan-line mt-10 w-24" />
      </div>
    </section>
  );
}
